export function getPortalApiBaseUrl() {
  const fromEnv = process.env.VUE_APP_API_BASE_URL
  const hasEnv = fromEnv != null && String(fromEnv).trim() !== ''

  if (process.env.NODE_ENV === 'development') {
    if (hasEnv) {
      return String(fromEnv).trim().replace(/\/$/, '')
    }
    return 'https://localhost:57720/api'
  }

  const fromRuntimeConfig = window.__PORTAL_CONFIG__?.API_BASE_URL
  if (fromRuntimeConfig != null && String(fromRuntimeConfig).trim() !== '') {
    return String(fromRuntimeConfig).trim().replace(/\/$/, '')
  }

  if (hasEnv) {
    return String(fromEnv).trim().replace(/\/$/, '')
  }

  return ''
}
